import { useQuery } from "@tanstack/react-query"
import { ApplicationRoleUser } from "../app/models/ApplicationRole"
import { digitalManagerApi } from "../services/api"

export function useRoleUsers(applicationId?: string, roleId?: string) {
  const { data: roleUsersList = [], isLoading: isLoadingRoleUsers } = useQuery({
    queryKey: ["roleUsers", applicationId, roleId],
    queryFn: () =>
      digitalManagerApi
        .get<
          ApplicationRoleUser[]
        >(`/applications/${applicationId}/roles/${roleId}/users`)
        .then((r) => r.data),
    enabled: !!applicationId && !!roleId,
  })

  return {
    roleUsersList,
    isLoadingRoleUsers,
  }
}
